<template>
  <div>
    <section
      class="hero is-fullheight is-pulled-up"
      :class="{ 'has-background-info': $experian }"
    >
      <div class="hero-body theme-background" :style="percaysoHeroStyle">
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-5-widescreen is-6-desktop is-8-tablet">
              <div v-if="login">
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <div class="section">
                      <LoginForm />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="columns is-mobile is-vcentered">
                  <div class="column">
                    <p class="title is-5 has-text-white">
                      Sign up to gain access to Percayso’s valuation tools
                    </p>
                  </div>
                </div>
                <div class="box">
                  <AuthSignup />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero benefits-banner">
      <div class="container">
        <div class="columns is-vcentered is-centered benefits-row">
          <div class="column is-narrow">
            <img
              :src="require('core/img/logos/retail_back.svg')"
              alt="Realtime valuations illustration"
              class="benefits-image"
            />
          </div>

          <div class="column benefits-copy">
            <h2 class="title is-4 has-text-weight-bold">
              Realtime valuations are here
            </h2>
            <p class="subtitle is-5">
              Cazana's values are updated in realtime from the current retail
              market. Cazana's valuations give an honest, unbiased, never edited
              view of today's retail environment to help you price, buy and sell
              stock more effectively.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="hero benefits-banner-dark">
      <div class="container">
        <div class="columns is-vcentered benefits-row-dark">
          <div class="column benefits-copy-dark">
            <h2 class="title is-4 has-text-weight-bold">Stop wasting money</h2>
            <p class="subtitle is-5">
              Picking the right stock to match customer demand is key in an
              increasingly competitive market. Cazana helps you understand what
              to buy, and what to avoid helping you make more money and turn
              stock faster.
            </p>
          </div>

          <div class="column is-narrow">
            <img
              :src="require('core/img/logos/losing_money.svg')"
              alt="Stop wasting money illustration"
              class="benefits-image-dark"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="hero benefits-banner">
      <div class="container">
        <div class="columns is-vcentered is-centered benefits-row">
          <div class="column is-narrow">
            <img
              :src="require('core/img/logos/lazy_stock.svg')"
              alt="Benefits illustration"
              class="benefits-image"
            />
          </div>

          <div class="column benefits-copy">
            <h2 class="title is-4 has-text-weight-bold">The price is right</h2>
            <p class="subtitle is-5">
              In today's fast moving automotive market prices change daily.
              Cazana shows every vehicle on the market – compare your stock with
              all the competition to make sure your price is right.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="hero featured-banner is-small">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-multiline is-vcentered is-spaced-between">
            <div class="column is-12 has-text-left">
              <p
                class="feature-banner-title is-6 has-text-weight-bold is-spaced"
              >
                Featured in
              </p>
            </div>
            <div class="column is-narrow">
              <img
                :src="require('core/img/logos/press/daily-mail.svg')"
                width="200"
                alt="Daily Mail"
              />
            </div>
            <div class="column is-narrow">
              <img
                :src="require('core/img/logos/press/the-telegraph.svg')"
                width="200"
                alt="The Telegraph"
              />
            </div>
            <div class="column is-narrow">
              <img
                :src="require('core/img/logos/press/the-times.svg')"
                width="200"
                alt="The Times"
              />
            </div>
            <div class="column is-narrow">
              <img
                :src="require('core/img/logos/press/the-sun.svg')"
                width="100"
                alt="The Sun"
              />
            </div>
            <div class="column is-narrow">
              <img
                :src="require('core/img/logos/press/daily-express.svg')"
                width="200"
                alt="Daily Express"
              />
            </div>
            <div class="column is-narrow">
              <img
                :src="require('core/img/logos/press/daily-star.svg')"
                width="80"
                alt="Daily Star"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import themeMixin from '@/mixins/theme'

export default {
  name: 'RootGuest',
  mixins: [themeMixin],
  components: {
    LoginForm: () => import('modules/login/components/LoginForm')
  },
  data: () => ({
    login: true,
    visible: {
      signUpForm: false
    }
  }),
  computed: {
    queryForm() {
      return this.$route.query.form
    }
  },
  methods: {
    toggle(section) {
      this.visible[section] = !this.visible[section]
    }
  }
}
</script>

<style lang="sass" scoped>
.benefits-banner
  background-color: #f8f9fa
  padding: 2rem 0
  font-family: 'Inter', sans-serif
  overflow-x: hidden

  .benefits-row
    gap: 0
    align-items: center
    margin-left: 0 !important
    margin-right: 0 !important

  .benefits-image
    width: 360px
    height: auto
    display: block
    max-width: 100%
    padding: 0 !important

  .benefits-copy
    max-width: 740px
    padding: 0 1.5rem !important

  .title
    color: $root-guest-title-color
    font-size: 1.5rem
    margin-bottom: 2rem

  .subtitle
    color: #666666
    line-height: 1.6
    font-size: 0.95rem

  @media screen and (max-width: 768px)
    .benefits-row
      flex-direction: column
      text-align: center
      gap: 0

    .benefits-image
      width: 380px
      margin: -4rem 0

    .benefits-copy
      max-width: 100%
      padding: 0rem 1rem 2rem !important
      position: relative
      z-index: 1

    .title
      font-size: 1.25rem


    .subtitle
      font-size: 0.85rem


.benefits-banner-dark
  background-color: $benefits-banner-dark-background-color
  padding: 2rem 0
  font-family: 'Inter', sans-serif
  overflow-x: hidden

  .benefits-row-dark
    gap: 2rem
    align-items: center
    margin-left: 0 !important
    margin-right: 0 !important

  .benefits-copy-dark
    max-width: 700px

  .benefits-image-dark
    width: 360px
    height: auto
    display: block
    max-width: 100%
    padding: 0 !important

  .title
    color: white
    font-size: 1.5rem
    margin-bottom: 2rem

  .subtitle
    color: #e0e0e0
    line-height: 1.6
    font-size: 0.95rem

  @media screen and (max-width: 768px)
    .benefits-row-dark
      flex-direction: column-reverse
      text-align: center

    .benefits-image-dark
      width: 380px
      margin: -2rem 0

    .benefits-copy-dark
      max-width: 100%

    .title
      font-size: 1.25rem

    .subtitle
      font-size: 0.85rem


.featured-banner
  background-color: $featured-banner-background-color

  img
    filter: brightness(0) invert(1)

.feature-banner-title
  color: #ffffff

.theme-background
  background-color: $login-background-color !important

.columns
  &.is-spaced-between
    justify-content: space-between
  &.is-flex-end
    align-items: flex-end
  &.is-reversed
    flex-direction: row-reverse
</style>
